// @ts-nocheck

import React, { useMemo } from 'react';
import type { Node } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as ArrowRight } from '../../../assets/svg/chevron-right.svg';
import { Target } from '../../../client';
import MatchToolbar from '../../../components/MatchToolbar/MatchToolbar';
import Formatter from '../../../i18n/formatter';
import { __ } from '../../../i18n/l10n';

const Wrap = styled.div`
  text-align: center;
  margin: 1em 0.6em 1em;
`;

const Title = styled.h3`
  color: #fff;
  margin: 0.2em auto;
`;

const Date = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  padding: 0.4em 0;
  font-family: BettingPoliticaBold, sans-serif;
`;

const Separator = styled.p`
  margin: 1em 0;
  color: #fff;
  text-align: left;
  display: flex;
  align-items: center;
  justify-items: center;
  white-space: nowrap;
`;

const Line = styled.span`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.grids.colors.darkgrey5};
  margin-left: 1em;
`;

const MainBet = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
`;

const Red = styled.span`
  color: ${({ theme }) => theme.grids.colors.redlight};
`;

const Bet = styled.div`
  margin: 1em 0.6em;
  width: 100%;
`;

const Odd = styled.p`
  color: ${({ theme }) => theme.grids.colors.yellow};
  border: solid 1px ${({ theme }) => theme.grids.colors.darkgrey4};
  border-radius: 1em;
  padding: 0.2em 0.6em;
  min-width: 30%;
  margin: 0;
`;

const Competitor = styled.p`
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  font-family: BettingPoliticaBold, sans-serif;
  margin: 0.4em 0;
`;

const LinkMatch = styled(Link)`
  && {
    margin: 0.4em 0;
    color: #fff;
    display: inline-block;
    width: 100%;
    text-align: right;
    text-decoration: underline;
    font-family: BettingPoliticaBold, sans-serif;
    text-transform: uppercase;
  }
`;

const Arrow = styled(ArrowRight)`
  color: ${({ theme }) => theme.grids.colors.redlight};
  width: 0.6em;
`;

const StyledMatchToolbar = styled(MatchToolbar)`
  background: transparent;
  &:not(:empty) {
    border-bottom: none;
  }

  .srm-tab-btm {
    border-right: none;
  }
`;

type Outcome = {
  label: string;
  value: number;
};

type Props = {
  className?: string;
  competitor1Name: string;
  competitor2Name: string;
  matchStart: number;
  matchId: number;
  mainBetOutcomes: Array<Outcome>;
};

const GridsHelpMatch = ({
  className,
  matchId,
  competitor1Name,
  competitor2Name,
  matchStart,
  mainBetOutcomes,
}: Props) => {
  const validMainBetOutcomes = useMemo(
    () => (mainBetOutcomes?.filter((k) => k).length === mainBetOutcomes ? mainBetOutcomes : null),
    [mainBetOutcomes],
  );

  return (
    <Wrap className={className}>
      {competitor1Name && competitor2Name ? (
        <Title>
          {competitor1Name} <Red>•</Red> {competitor2Name}
        </Title>
      ) : null}
      {matchStart ? <Date>{Formatter.formatDate(matchStart, 'longDate')}</Date> : null}
      {validMainBetOutcomes ? (
        <Separator>
          {__('Match result odds')}
          <Line />
        </Separator>
      ) : null}
      {validMainBetOutcomes ? (
        <MainBet>
          {validMainBetOutcomes.map<Node>(({ label, value }) => (
            <Bet key={label}>
              <Odd>{value}</Odd>
              <Competitor>{label}</Competitor>
            </Bet>
          ))}
        </MainBet>
      ) : null}
      <LinkMatch to={`/match/${matchId}`}>
        {__('See all odds')} <Arrow />
      </LinkMatch>
      {/* SportRadar widget without stream so no need to be connected, etc */}
      <StyledMatchToolbar
        matchId={matchId}
        alreadyOpen
        isMobile={Target.__MOBILE__}
        hasTracker={true}
        options={{ forceTeamInvert: false }}
      />
    </Wrap>
  );
};

export default GridsHelpMatch;
